export class AlertLevels {
    public static readonly INFORMATIONAL = 'theme';
    public static readonly ERROR = 'error';
    public static readonly WARNING = 'warning';
    public static readonly SUCCESS = 'success';
    public static readonly UNDEFINED = undefined;
}

export type AlertLevel = 'theme' | 'error' | 'warning' | 'success' | undefined;